import moment, { Moment } from 'moment';
import { NegotiationExtraInfo, NegotiationOption, OutDebt } from '../../generated/graphql';
import { getNegBooleans } from '../../utils/getNegBooleans';

export interface UseGetMaxPaymentDateProps {
  outDebt?: OutDebt;
  option?: NegotiationOption;
  extraInfo?: NegotiationExtraInfo;
  useMaxPaymentDateOverride?: boolean;
}

export const useGetMaxPaymentDate = (props: UseGetMaxPaymentDateProps) => {
  const {
    outDebt,
    option,
    extraInfo,
    useMaxPaymentDateOverride = false,
  } = props;
  const {
    isRefinance, isNormalization, isACPK,
    isInstallmentsPlan, isTotalPayment, isRappiPay, isRappiPrestamo, isBbva,
    isDav, isBeta, isPichincha, isExpressRefinance, isMovistarMoney, isModification,
    isBogota, isBalanceBehindPayment, isApex, isClaro,
  } = getNegBooleans(outDebt, option);
  const useMaxPaymentDate = isRefinance || isNormalization
  || isRappiPay || isRappiPrestamo || isModification
    || ((isACPK || isTotalPayment || isInstallmentsPlan)
    && (isDav || isBeta || isBbva || isMovistarMoney || isApex || isClaro))
    || (isPichincha || isExpressRefinance)
    || (isBogota && isBalanceBehindPayment);
  const formatDate = (inputDate?: Date | string | Moment, format = 'LL') => {
    const date = moment(inputDate);
    return date.isValid() ? date.format(format) : '';
  };

  const rawDate = (useMaxPaymentDate || useMaxPaymentDateOverride)
    ? option?.settings?.maxPaymentDate : extraInfo?.paymentDate;
  return formatDate(rawDate);
};
